var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function () {
          return [
            _c("UiButton", {
              attrs: {
                variant: "secondary",
                buttonText: _vm.buttonText,
                fullWidth: "",
              },
              on: { click: _vm.showModal },
            }),
          ]
        },
        { showModal: _vm.showModal }
      ),
      _vm.modalShown
        ? _c("ActivityFormModal", {
            attrs: {
              project: _vm.project,
              projectActivity: _vm.projectActivity,
              currentUserRole: _vm.currentUserRole,
              companyId: _vm.companyId,
            },
            on: {
              activityAdded: _vm.onActivityAdded,
              activityUpdated: _vm.hideModal,
              close: _vm.hideModal,
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }